import React from "react"
import * as styles from "./CardsSection.module.scss"
import { Card, CardProps } from "@shared/uiNew/Card"
import { MarkedTitle } from "@shared/uiNew/MarkedTitle"
import Button, { IButton } from "@shared/uiNew/Button/button"

type MarkerVariant = "program" | "topics" | "speakers"
type CardsLayout = "grid" | "centered_rows"

type Props = {
  id?: string
  className?: string
  classNameMarker?: string

  // Header
  title?: React.ReactNode
  titleTail?: React.ReactNode
  description?: React.ReactNode
  markerAnimationData: unknown
  markerVariant?: MarkerVariant

  columns?: number

  // Cards
  items: Array<CardProps & { key?: string }>

  withBg?: boolean
  bgColor?: string

  textButton?: string
  buttonProps?: IButton
  cardsLayout?: CardsLayout
}

const cx = (...c: Array<string | undefined | false>) => c.filter(Boolean).join(" ")

export const CardsSection: React.FC<Props> = ({
  id,
  className,
  classNameMarker,
  title,
  description,
  titleTail,
  markerAnimationData,
  markerVariant = "program",
  items,
  withBg = false,
  bgColor = "#fff",
  columns = 3,
  textButton = "Зарегистрироваться на вебинар",
  buttonProps,
  cardsLayout = "grid",
}) => {
  const bgStyle = withBg
    ? {
        backgroundImage: `
          radial-gradient(circle, #00000014 2.5px, transparent 2.5px),
          linear-gradient(180deg, ${bgColor} 0%, rgba(167, 167, 255, 0) 100%)
        `,
      }
    : { backgroundColor: `${bgColor}` }

  const gridStyle = cardsLayout === "grid" ? { gridTemplateColumns: `repeat(${columns}, 1fr)` } : { ["--cards-columns" as string]: String(columns) }

  return (
    <section id={id} className={cx(styles.section, className, withBg && styles.withBg)} style={bgStyle}>
      <div className={`${styles.container} ${items.length === 1 ? styles.containerOne : styles.containerDef}`}>
        {title && (
          <h2 className={`${styles.title} h1`}>
            <MarkedTitle markerAnimationData={markerAnimationData} className={classNameMarker} variant={markerVariant}>
              {title}
            </MarkedTitle>
            {titleTail ? <> {titleTail}</> : null}

            {items.length === 1 && <Button icon="arrow" href="#form" style={styles.button} text={textButton} />}
          </h2>
        )}

        {description && <p className={styles.desc}>{description}</p>}

        <div className={cx(styles.grid, cardsLayout === "centered_rows" && styles.gridCenteredRows)} style={gridStyle}>
          {items.map((it, idx) => (
            <div key={it.key ?? idx} className={styles.cardItem}>
              <Card {...it} />
            </div>
          ))}
        </div>
      </div>

      {markerVariant === "speakers" && items.length > 1 && <Button icon="arrow" href="#form" style={styles.button} text={textButton} />}

      {buttonProps && <Button {...buttonProps} />}
    </section>
  )
}
